export default {
  state: {
    platformList: [],
  },
  getters: {
    platform: (state: any) => (uid: string) => {
      return state.platformList.find((value: any) => {
        return value.uid == uid;
      });
    },
  },
  mutations: {
    setPlatformList: (state: any, platformList: any[]) => {
      state.platformList = platformList;
    },

    // 清空数据
    resetState: (state: any) => {
      state.platformList = [];
    },
  },
};
